var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalTitle },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ invalid, dirty }) {
                    return [
                      _c(
                        "ModalContent",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "actions",
                                fn: function () {
                                  return [
                                    _c("UiButton", {
                                      staticClass: "mr-3",
                                      attrs: {
                                        id: "cancelGroup",
                                        variant: "outline",
                                        buttonText: "Cancel",
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _vm.data
                                      ? _c("UiButton", {
                                          attrs: {
                                            type: "submit",
                                            id: "updateGroup",
                                            disabled: invalid,
                                            buttonText: "Update",
                                          },
                                          on: { click: _vm.handleSubmit },
                                        })
                                      : _c("UiButton", {
                                          attrs: {
                                            type: "submit",
                                            id: "createGroupM",
                                            disabled: invalid || !dirty,
                                            buttonText: "Create",
                                          },
                                          on: { click: _vm.handleSubmit },
                                        }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm.hideContractorsMessage
                            ? _c("WindowAlerts", {
                                staticClass: "mb-4 -mt-1",
                                attrs: { items: _vm.alerts },
                              })
                            : _vm._e(),
                          _c("ValidationProvider", {
                            attrs: {
                              rules: "required_field",
                              name: "Group Name",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("FormGroup", {
                                        attrs: {
                                          errors: errors,
                                          name: "project_title",
                                          placeholder: "Enter name",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [_vm._v(" Group Name* ")]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.group.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.group, "name", $$v)
                                          },
                                          expression: "group.name",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("ValidationProvider", {
                            attrs: {
                              name: "contractors",
                              rules: _vm.contractorRules,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors, failed }) {
                                    return [
                                      _c(
                                        "FormGroup",
                                        {
                                          attrs: {
                                            errors: errors,
                                            name: "contractor",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.contractorsTitle
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("ContractorsMultiselect", {
                                            attrs: {
                                              value: _vm.selectedContractorsIds,
                                              invalid: failed,
                                              contractorsConditions:
                                                _vm.contractorsWhere,
                                              placeholder: "Select contractors",
                                              title: "Contractors",
                                            },
                                            on: {
                                              input: _vm.handleContractorInput,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm.showManagersFilter
                            ? _c(
                                "FormGroup",
                                {
                                  attrs: { name: "managers" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function () {
                                          return [_vm._v(" Managers ")]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("ManagersMultiselect", {
                                    attrs: {
                                      value: _vm.managersIds,
                                      placeholder: "Select managers",
                                      title: "Managers",
                                    },
                                    on: { input: _vm.handleManagerInput },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "FormGroup",
                            {
                              attrs: { name: "skills" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [_vm._v(" Skills ")]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("CustomSkillsMultiselect", {
                                attrs: {
                                  previouslyChosenSkillsIds: _vm.group.skills,
                                  customSkillLabel: "Add personal skill",
                                },
                                on: { skillsListUpdated: _vm.updateSkills },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroupNew",
                            {
                              attrs: {
                                name: "projects",
                                inputClass: "fullwidthInput",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [_c("p", {}, [_vm._v("Projects")])]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("ProjectsMultiselect", {
                                attrs: {
                                  value: _vm.chosenProjectsIds,
                                  getcontainerStyle:
                                    "smallHeight customWidthInput customHeightInput",
                                  projectsConditions: _vm.projectsWhere,
                                },
                                on: { input: _vm.handleProjectInput },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              attrs: { name: "postings" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [_vm._v(" Postings ")]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("PostingsMultiselect", {
                                attrs: {
                                  value: _vm.postingValue,
                                  title: "Postings",
                                  postingsConditions: _vm.postingsWhere,
                                },
                                on: { input: _vm.handlePostingInput },
                              }),
                            ],
                            1
                          ),
                          _c("FormGroup", {
                            attrs: {
                              name: "group_location",
                              placeholder: "Enter location",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [_vm._v(" Location ")]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.group.location,
                              callback: function ($$v) {
                                _vm.$set(_vm.group, "location", $$v)
                              },
                              expression: "group.location",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }